import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IContentItem } from '@kontent-ai/delivery-sdk';
import { getLinkedItems } from 'src/app/core/content-utilities';

@Component({
  selector: 'app-block-overview-section',
  templateUrl: './block-overview-section.component.html',
  styleUrls: ['./block-overview-section.component.scss']
})
export class BlockOverviewSectionComponent implements OnInit {

  @Input() content: IContentItem | null = null;
  safeBodyHtml: SafeHtml | null = null;

  public blocks : {header: SafeHtml, body: SafeHtml, bgColor: string}[] = []

  constructor(
    private sanitizer: DomSanitizer
    ) { }

  ngOnInit(): void {
    if(!this.content) return;
    
    const unsafeHtml = this.content.elements['body'].value;
    this.safeBodyHtml = this.sanitizer.bypassSecurityTrustHtml(unsafeHtml);

    const blocks = getLinkedItems(this.content, 'blocks')

    this.blocks = blocks.map((block) => ({
      header: this.sanitizer.bypassSecurityTrustHtml(block.elements['header'].value),
      body: this.sanitizer.bypassSecurityTrustHtml(block.elements['body'].value),
      bgColor: block?.elements['header_color']?.value || 'bg-yellow',
    }))
  }

}
